import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PROGRAM_BASE_PATH } from '../../../../../features/userauth/program/program-routing';

export const Route = createFileRoute('/_app/_platform/_context-required/program/_program')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'programs',
        label: 'Programs',
        to: PROGRAM_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
